<template>
  <div class="container">
    <div class="container-top">
      <div class="container-top-left">
        <div class="title-logo">
          <img src="../../../static/img/docCenter/songbai_logo.svg" alt="">
          <span class="title-logo-text">松佰商城开放平台文档中心</span>
        </div>
        <div class="relative">
          <div class="select-box" @click="changeShow()">
            <span class="text groupItem" :title="selectGroupItem">{{selectGroupItem}}</span>
            <img src="../../../static/img/docCenter/arrow_down.svg" alt="">
          </div>
          <div class="absolute api-doc-list" v-if="isShow">
            <div class="api-doc-item" v-for="(item,index) in groupList" :key="index" @click="changeGroupItem(item)"
                 :title="item.group_name">{{item.group_name}}
            </div>
          </div>
        </div>
      </div>
      <div class="container-top-right">
        <div class="search-box" v-if="!isShowLongSearch">
          <input type="text" class="search" @focus="showLongSearch" placeholder="搜索文档关键字">
          <img src="../../../static/img/docCenter/search_icon.svg" alt="" class="search-icon">
        </div>
        <div class="search-long-box relative" v-if="isShowLongSearch">
          <input type="text" class="search" v-model="searchKey" placeholder="搜索文档关键字" maxlength="30">
          <img src="../../../static/img/docCenter/search_icon.svg" alt="" class="search-icon" @click="search()">
          <div class="line"></div>
          <img src="static/img/docCenter/close_search.svg" @click="showSearch" alt="" class="search-icon">
          <div class="absolute history-box" v-if="historySearchList.length>0">
            <span class="history-search-text">历史搜索</span>
            <div class="history-list">
              <span class="history-item" @click="search(item)" v-for="(item,index) in historySearchList" :key="index">{{item}}</span>
            </div>
          </div>
        </div>
        <div class="console-box" @click="gotoLogin">
          <span class="console">控制台</span>
        </div>
        <div class="login-box" @click="gotoLogin">
          <span>登录 / 注册</span>
        </div>
      </div>
    </div>
    <div class="container-content">
      <div class="container-content-left">
        <div class="directory">目录</div>
        <el-collapse v-model="activeNames" accordion @change="handleChange">
          <el-collapse-item :title="item.sort_name" :name="index" v-for="(item,index) in sortList" :key="index">
            <template #title>
              <div class="el-collapse-item-title" :title="item.sort_name">{{item.sort_name}}</div>
            </template>
            <div class="doc-name-item" :class="item.id == docId?'directory-active':''"
                 v-for="(item,index) in docList" :key="index" @click="clickDocName(item,index)" :title="item.doc_name">{{item.doc_name}}
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="container-content-center">
        <div class="breadcrumb_box">
          <span class="first_title">{{sort_name}} / </span>
          <span class="second_title">{{doc_name}}</span>
        </div>
        <div class="api_message_box">
          <span class="line"></span>
          <div class="api_base_message_box">
            <span>{{detail.is_free == 1?'免费':detail.is_free == 0?'收费':''}}</span>
            <span>{{detail.is_limit == 1?'有调用限制':detail.is_limit == 0?'无调用限制':''}}</span>
            <span>版本{{detail.version}}</span>
            <span>更新时间：{{detail.update_time}}</span>
          </div>
        </div>
        <div class="name_and_back">
          <div><p><span>方法名称：</span><span class="name_text">{{detail.method}}</span></p></div>
          <div><p><span>使用场景：</span><span class="back_text">{{detail.scene}}</span></p></div>
        </div>
        <div class="content-box">
          <div class="common-title" id="nav0">公共参数</div>
          <div class="small-common-title"><span class="dot"></span>请求地址</div>
          <table class="table">
            <tr>
              <th class="f14 color666">测试环境地址</th>
              <th class="f14 color666">生产环境地址</th>
            </tr>
            <tr>
              <td class="color409EFF">{{detail.test_url}}</td>
              <td class="color409EFF">{{detail.prod_url}}</td>
            </tr>
          </table>
          <div class="small-common-title"><span class="dot"></span>公共请求参数</div>
          <div class="mini-common-title">url参数：这些参数需要附加在请求 URL 后面，格式为：?key1=value1&key2=value2。</div>
          <el-table :data="detail.pubparam" v-loading="loading"
                    default-expand-all
                    :header-cell-style="{background:'#E6E6E6', color:'#333'}"
                    element-loading-text="拼命加载中">
            <el-table-column prop="name" label="名称">
              <template slot-scope="scope" style="position: relative">
                <div>{{scope.row.name}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="类型">
              <template slot-scope="scope">
                <div>{{scope.row.type}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="must" label="是否必须">
              <template slot-scope="scope">
                <div>{{scope.row.must?'是':'否'}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="desc" label="描述">
              <template slot-scope="scope">
                <div>{{scope.row.desc}}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="content-box">
          <div class="common-title" id="nav1">请求参数</div>
          <div class="mini-common-title">body参数：这些参数需要放在请求体中（适用于POST请求）格式为：{"key3":"value3","key4":"value4"}。</div>
          <el-table :data="detail.reqparam" v-loading="loading"
                    row-key="id"
                    default-expand-all
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    :expand-row-keys="expandRowKeys"
                    :header-cell-style="{background:'#E6E6E6', color:'#333'}"
                    element-loading-text="拼命加载中">
            <el-table-column prop="name" label="名称">
              <template slot-scope="scope">
                <div class="text_deal_1" style="width: 120px;display: inline-block" :title="scope.row.name">{{scope.row.name}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="类型">
              <template slot-scope="scope">
                <div>{{scope.row.type}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="must" label="是否必须">
              <template slot-scope="scope">
                <div>{{scope.row.must?'是':'否'}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="desc" label="描述">
              <template slot-scope="scope">
                <div>{{scope.row.desc}}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="content-box">
          <div class="common-title" id="nav2">响应参数</div>
          <el-table :data="detail.resparam" v-loading="loading"
                    row-key="id"
                    default-expand-all
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    :expand-row-keys="expandRowKeys"
                    :header-cell-style="{background:'#E6E6E6', color:'#333'}"
                    element-loading-text="拼命加载中">
            <el-table-column prop="name" label="名称">
              <template slot-scope="scope">
                <div class="text_deal_1" style="width: 120px;display: inline-block" :title="scope.row.name">{{scope.row.name}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="类型">
              <template slot-scope="scope">
                <div>{{scope.row.type}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="desc" label="描述">
              <template slot-scope="scope">
                <div>{{scope.row.desc}}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="content-box">
          <div class="common-title" id="nav3">响应示例</div>
          <div class="json-content">
            <json-viewer :value="resExampleData" theme="my-awesome-json-theme"></json-viewer>
          </div>
        </div>
        <div class="content-box">
          <div class="common-title" id="nav4">异常示例</div>
          <div class="json-content">
            <json-viewer :value="errorExampleData" theme="my-awesome-json-theme"></json-viewer>
          </div>
        </div>
        <div class="content-box">
          <div class="common-title" id="nav5">错误码</div>
          <el-table :data="detail.error_code" v-loading="loading"
                    default-expand-all
                    :header-cell-style="{background:'#E6E6E6', color:'#333'}"
                    element-loading-text="拼命加载中">
            <el-table-column prop="error_code" label="错误码">
              <template slot-scope="scope">
                <div>{{scope.row.error_code}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="error_desc" label="错误描述">
              <template slot-scope="scope">
                <div>{{scope.row.error_desc}}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="content-box">
          <div class="common-title" id="nav6">常见Q&A</div>
          <el-table :data="detail.qa" v-loading="loading"
                    default-expand-all
                    :header-cell-style="{background:'#E6E6E6', color:'#333'}"
                    element-loading-text="拼命加载中">
            <el-table-column prop="question" label="问题">
              <template slot-scope="scope">
                <div>{{scope.row.question}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="solution" label="解决方案">
              <template slot-scope="scope">
                <div>{{scope.row.solution}}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="container-content-right">
        <div class="page-directory">本页目录</div>
        <div class="nav">
          <p :class="navIndex==index?'nav-on':''" v-for="(item,index) in navList" :key="index" @click="nav(index)">
            {{item}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {indexGetById, indexDocList, indexGroupList, indexSortList} from '../../api/basisMG'
  import JsonViewer from 'vue-json-viewer'
  export default {
    name: "docCenter",
    components:{
      JsonViewer
    },
    data() {
      return {
        loading: false, //是显示加载
        activeNames: 0,
        navIndex: 0,
        activeIndex: '999',
        isShow: false,
        groupId: '',
        sortId: '',
        docId: '',
        groupList: [],
        sortList: [],
        docList: [],
        detail: {},
        sort_name: '',
        doc_name: '',
        selectGroupItem: '',
        resParam: [],
        reqParam: [],
        expandRowKeys: [],
        isShowLongSearch: false,
        historySearchList: [],
        searchKey: '',
        resExampleData:'',
        errorExampleData:'',
        navList: ['公共参数', '请求参数', '响应参数', '响应示例', '异常示例', '错误码', '常见Q&A']
      };
    },
    mounted() {
      if (this.$route.query.groupId) {
        this.groupId = this.$route.query.groupId;
        this.sortId = this.$route.query.sortId;
        this.docId = this.$route.query.docId;
        this.getGroupList(this.groupId, this.sortId, this.docId)
      } else {
        this.getGroupList()
      }
      window.addEventListener("scroll", this.handleScroll, true); // 监听（绑定）滚轮滚动事件
    },
    methods: {
      handleScroll(e) {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if(document.querySelector('#nav1') != null) {
          let offsetTop1 = document.querySelector('#nav1').offsetTop;
          let offsetTop2 = document.querySelector('#nav2').offsetTop;
          let offsetTop3 = document.querySelector('#nav3').offsetTop;
          let offsetTop4 = document.querySelector('#nav4').offsetTop;
          let offsetTop5 = document.querySelector('#nav5').offsetTop;
          let offsetTop6 = document.querySelector('#nav6').offsetTop;
          // console.log(scrollTop, '滚动距离')
          // console.log(offsetTop2, '滚动距离')
          if (scrollTop < offsetTop1) {
            this.navIndex = 0;
          } else if (scrollTop >= offsetTop1 && scrollTop < offsetTop2) {
            this.navIndex = 1;
          } else if (scrollTop >= offsetTop2 && scrollTop < offsetTop3) {
            this.navIndex = 2;
          } else if (scrollTop >= offsetTop3 && scrollTop < offsetTop4) {
            this.navIndex = 3;
          } else if (scrollTop >= offsetTop4 && scrollTop < offsetTop5) {
            this.navIndex = 4;
          } else if (scrollTop >= offsetTop5 && scrollTop < offsetTop6) {
            this.navIndex = 5;
          } else {
            this.navIndex = 6;
          }
        }
      },
      handleChange() {
        if (typeof this.activeNames == "number") {
          let body = {
            groupId: this.groupId,
            sortId: this.sortList[this.activeNames].id,
            status: 1,
            isRecommend:''
          }
          indexDocList(body).then(res => {
            if (res.success) {
              this.docList = res.content.rows;
              this.activeIndex = '999'
            }
          }).catch(err => {

          })
        }
      },
      gotoLogin() {
        this.$router.push({path: '/login'})
      },
      nav(index) {
        this.navIndex = index;
        document.documentElement.scrollTop = document.querySelector("#nav" + index).offsetTop
        // document.getElementById("nav" + index).scrollIntoView({behavior: 'smooth'});
      },
      // 获取API类型名称
      getGroupList(groupId, sortId, docId) {
        indexGroupList().then(res => {
          if (res.success) {
            this.groupList = res.content.rows;
            if (groupId) {
              this.groupList.forEach((item) => {
                if (item.id == groupId) {
                  this.selectGroupItem = item.group_name;
                  this.groupId = item.id || '';
                  this.getSortList(item.id, sortId, docId)
                }
              })
            } else {
              this.selectGroupItem = res.content.rows[0].group_name;
              this.groupId = res.content.rows[0].id || '';
              this.getSortList(res.content.rows[0].id)
            }
          }
        })
          .catch(err => {

          })
      },
      getSortList(id, sortId, docId) {
        indexSortList(id).then(res => {
          if (res.success) {
            this.sortList = res.content.rows;
            if (sortId) {
              this.sortList.forEach((item, index) => {
                if (item.id == sortId) {
                  this.activeNames = index;
                  this.getDocList(item, docId)
                }
              })
            } else {
              this.activeNames = 0;
              this.getDocList(res.content.rows[0])
            }

          }
        }).catch(err => {

        })
      },
      getDocList(item, docId) {
        let body = {
          groupId: this.groupId,
          sortId: item.id,
          status: 1,
          isRecommend:''
        }
        indexDocList(body).then(res => {
          if (res.success) {
            this.docList = res.content.rows;
            if (docId) {
              this.docList.forEach((item, index) => {
                if (item.id == docId) {
                  this.clickDocName(item, index)
                }
              })
            } else {
              this.clickDocName(res.content.rows[0], 0)
            }

          }
        }).catch(err => {

        })
      },
      changeShow() {
        this.isShow = !this.isShow;
      },
      changeGroupItem(item) {
        this.selectGroupItem = item.group_name;
        this.groupId = item.id;
        this.getSortList(item.id)
        this.isShow = false;
      },
      clickDocName(item, index) {
        this.activeIndex = index;
        this.sort_name = item.sort_name;
        this.doc_name = item.doc_name;
        this.docId = item.id;
        this.detail = {};
        console.log(item)
        indexGetById(item.id).then(res => {
          if (res.success) {
            this.detail = res.content;
            this.resParam = [];
            this.reqParam = [];
            this.resExampleData = eval("(" + res.content.resp_inst + ")")||{};
            this.errorExampleData = eval("(" + res.content.ex_inst + ")")||{};
            this.$router.push({
              query: {
                groupId:res.content.group_id,
                sortId:res.content.sort_id,
                docId:res.content.id
              }
            })
            res.content.resparam.forEach((item) => {
              let obj = eval("(" + item + ")");
              this.resParam.push(obj);
            })
            res.content.reqparam.forEach((item) => {
              let obj = eval("(" + item + ")");
              this.reqParam.push(obj);
            })
          }
        }).catch(err => {

        })
      },
      showLongSearch() {
        this.isShowLongSearch = true;
        if (localStorage.getItem('historyList')) {
          this.historySearchList = JSON.parse(localStorage.getItem('historyList'))
        }
      },
      showSearch() {
        this.isShowLongSearch = false;
      },
      search(item) {
        if (item) {
          this.searchKey = item;
        }
        if(this.searchKey == ''||this.searchKey == undefined||this.searchKey == null) {
          return;
        }
        if (this.historySearchList.includes(this.searchKey)) {
          localStorage.setItem('historyList', JSON.stringify(this.historySearchList))
          this.$router.push({path: '/docCenter/docSearch', query: {searchKey: this.searchKey}})
          return;
        } else {
          if (this.historySearchList.length >= 10) {
            this.historySearchList.pop();
          }
          this.historySearchList.unshift(this.searchKey)
          localStorage.setItem('historyList', JSON.stringify(this.historySearchList))
          this.$router.push({path: '/docCenter/docSearch', query: {searchKey: this.searchKey}})
        }
      }
    },
    destroyed() { //离开这个界面之后，删除滚动事件，不然容易除bug
      window.removeEventListener('scroll', this.handleScroll)
    },
  }
</script>

<style scoped>
  .container {
    background: #fff;
  }

  .container-top {
    height: 60px;
    border-bottom: 2px solid #E6E6E6;
    display: flex;
    justify-content: space-between;
    background: #fff;
  }

  .container-top-left {
    display: flex;
    align-items: center;
  }

  .container-top-right {
    display: flex;
    align-items: center;
  }

  .title-logo {
    display: flex;
    align-items: center;
    margin-left: 30px;
  }

  .title-logo-text {
    margin-left: 4px;
    font-weight: 700;
    font-size: 16px;
    color: #333;
  }

  .select-box {
    width: 148px;
    height: 32px;
    line-height: 32px;
    border: 1px solid #ccc;
    border-radius: 99px;
    margin-left: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #333;
    cursor: pointer;
  }

  .select-box .text {
    margin-right: 8px;
  }

  .login-box span {
    display: inline-block;
    width: 132px;
    line-height: 60px;
    height: 60px;
    background: #409EFF;
    text-align: center;
    font-size: 15px;
    color: #fff;
    cursor: pointer;
  }

  .console {
    color: #409EFF;
    font-size: 15px;
    margin: 0 40px 0 50px;
    padding: 4px 8px;
    font-weight: 700;
  }

  .console:hover {
    cursor: pointer;
    border-radius: 2px;
    background: #F4F4F4;
  }

  .search-box {
    display: flex;
    align-items: center;
    background: #F4F4F4;
    width: 216px;
    height: 32px;
  }

  .search-long-box {
    display: flex;
    align-items: center;
    background: #F4F4F4;
    width: 560px;
    height: 32px;
  }

  .search-long-box .search {
    border: none;
    height: 30px;
    outline: none;
    width: 470px;
    padding-left: 8px;
    background: #F4F4F4;
  }

  .search-box .search {
    border: none;
    height: 30px;
    outline: none;
    width: 164px;
    padding-left: 8px;
    background: #F4F4F4;
  }

  .search-icon {
    margin-left: 12px;
    cursor: pointer;
  }

  .container-content {
    width: 1350px;
    margin: 40px auto;
    display: flex;
  }

  .container-content-left {
    width: 220px;
  }

  .container-content-center {
    width: 900px;
    margin-left: 60px;
    margin-bottom: 42px;
  }

  /deep/ .el-collapse {
    border: 0;
  }

  /deep/ .el-collapse-item__header {
    border: 0;
    height: 36px;
    line-height: 36px;
  }

  /deep/ .el-collapse-item__wrap {
    border: 0;
  }

  /deep/ .el-collapse-item__content {
    padding-bottom: 0;
  }

  /deep/ .el-collapse-item__content div {
    height: 36px;
    line-height: 36px;
    text-align: left;
    padding-left: 25px;
    display: -webkit-box;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }

  .directory-active {
    background: #ECF5FF;
    color: #409EFF;
  }

  .directory {
    font-size: 18px;
    font-weight: 700;
    color: #333;
    height: 36px;
    line-height: 36px;
  }

  .breadcrumb_box {
    margin-bottom: 24px;
  }

  .first_title {
    color: #999;
    font-size: 14px;
  }

  .second_title {
    color: #333;
    font-size: 14px;
  }

  .api_message_box {
    margin-bottom: 22px;
    display: flex;
  }

  .api_message_box .line {
    width: 3px;
    height: 20px;
    background: #ccc;
    border-radius: 99px;
    margin-right: 20px;
    display: block;
  }

  .api_base_message_box {
    width: 800px;
    border-bottom: 1px solid #F4F4F4;
  }

  .api_base_message_box span {
    margin-right: 40px;
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    color: #666;
  }

  .name_and_back {
    background: rgba(244, 244, 244, 0.7);
    width: 854px;
    padding: 20px 23px 10px;
  }

  .name_and_back p {
    color: #666666;
    font-size: 14px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }

  .name_and_back p .name_text, .name_and_back p .back_text {
    display: inline-block;
  }

  .common-title {
    font-size: 28px;
    font-weight: 700;
    color: #333;
    margin-top: 22px;
    line-height: 42px;
    margin-bottom: 12px;
  }

  .small-common-title {
    font-size: 18px;
    color: #333;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    padding-left: 12px;
  }

  .small-common-title .dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    display: inline-block;
    background: #333;
    margin-right: 8px;
  }

  .mini-common-title {
    font-size: 12px;
    color: #333;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    padding-left: 12px;
  }

  .table {
    width: 900px;
    border-collapse: collapse;
    margin-bottom: 40px;
  }

  .table tr th {
    text-align: center;
    border: 1px solid #E6E6E6;
    height: 50px;
  }

  .table tr td {
    text-align: center;
    border: 1px solid #E6E6E6;
    height: 50px;
  }

  .common-table {
    width: 900px;
    border-collapse: collapse;
    margin-bottom: 40px;
  }

  .common-table tr th {
    text-align: left;
    border-bottom: 1px solid #E6E6E6;
    height: 50px;
    padding-left: 30px;
    font-size: 14px;
    color: #333;
    background: #E6E6E6;
  }

  .common-table tr td {
    text-align: left;
    border-bottom: 1px solid #E6E6E6;
    padding-left: 30px;
    height: 50px;
    font-size: 14px;
    color: #666;
  }

  .json-content {
    background: rgba(244, 244, 244, 0.7);
    padding: 20px 30px;
  }

  .page-directory {
    font-size: 14px;
    font-weight: 700;
    color: #333;
    height: 32px;
    line-height: 32px;
  }

  .nav {
    margin-left: 15px;
    margin-top: 5px;
  }

  .nav p {
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    border-left: 1px solid #ccc;
    padding-left: 20px;
    color: #666;
    cursor: pointer;
  }

  .nav .nav-on {
    color: #409EFF;
  }

  .container-content-right {
    margin-left: 70px;
    position: fixed;
    left: 50%;
    margin-left: 600px;
  }

  .absolute {
    position: absolute;
  }

  .api-doc-list {
    width: 148px;
    background: #fff;
    top: 36px;
    left: 20px;
    border-radius: 3px;
    z-index: 99;
    box-shadow: 5px 5px 10px 0px rgba(51, 51, 51, 0.1);
  }

  .history-box {
    width: 560px;
    background: #fff;
    top: 36px;
    left: 0px;
    border-radius: 3px;
    z-index: 99;
    box-shadow: 5px 5px 10px 0px rgba(51, 51, 51, 0.1);
  }

  .history-list {
    padding-left: 15px;
  }

  .history-item {
    display: inline-block;
    padding: 5px 10px;
    background: #F4F4F4;
    margin-right: 12px;
    color: #666;
    font-size: 12px;
    margin-bottom: 10px;
    cursor: pointer;
  }

  .history-item:hover {
    background: rgba(64, 158, 255, 0.1);
    color: #409EFF;
  }

  .history-search-text {
    display: inline-block;
    font-size: 14px;
    color: #666666;
    padding: 15px 0 10px 15px;
  }

  .api-doc-item {
    height: 22px;
    line-height: 22px;
    color: #666;
    margin: 4px;
    padding-left: 4px;
    cursor: pointer;
    font-size: 14px;
    width: 136px;
    display: -webkit-box;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }

  .api-doc-item:hover {
    background: #f4f4f4;
  }

  .groupItem {
    display: inline-block;
    max-width: 100px;
    display: -webkit-box;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }

  .doc-name-item {
    cursor: pointer;
  }

  .line {
    width: 1px;
    height: 12px;
    background: #999999;
    margin-left: 12px;
  }
  .el-collapse-item-title {
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .text_deal_1 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  /deep/ .el-table td.el-table__cell div {
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/docCenter/docCenter.vue